import checkboxCheckIcon from '@xero/xui-icon/icons/checkbox-check';
import XUIIcon from '@xero/xui/react/icon';
import { XUIPanel, XUIPanelSection } from '@xero/xui/react/panel';
import { FC } from 'react';

export interface IFeaturesComparisonProps {
    planDescriptions: IPlanDescription[];
}

export interface IPlanDescription {
    HEADING?: string;
    FEATURES: string[];
    PRICE?: string;
    CAPSULE?: string;
}

export const FeaturesComparison: FC<IFeaturesComparisonProps> = ({ planDescriptions }) => {
    if (!planDescriptions.length) {
        return <div />;
    }
    const panels = planDescriptions.map((plan, i) => {
        const heading = plan.HEADING ? (
            <>
                {plan.HEADING} {plan.CAPSULE}
            </>
        ) : undefined;
        return (
            <XUIPanel key={i} className='xui-padding-large xui-textcolor-muted xui-column-12-of-12'>
                <XUIPanelSection
                    headerClassName='xui-text-align-left xui-textcolor-standard xui-heading-medium'
                    heading={heading}
                >
                    <>
                        {!plan.PRICE || <div className='xui-text-muted'>{plan.PRICE}</div>}
                        {plan.FEATURES.map((feature) => (
                            <div key={`${i}-${feature}`} className='feature-row xui-padding-top'>
                                <XUIIcon icon={checkboxCheckIcon} color='green' className='xui-margin-right' />
                                {feature}
                            </div>
                        ))}
                    </>
                </XUIPanelSection>
            </XUIPanel>
        );
    });

    return (
        <>
            <p className='xui-heading-large'>Pricing plans</p>
            <div className='xui-row-grid xui-u-flex xui-margin-bottom-xlarge'>{panels}</div>
        </>
    );
};
